import React, { useState } from "react";
import get_preview_url from "./utils/get_preview_url";

// const DEVELOPMENT = "DEVELOPMENT";
// const STAGING = "STAGING";

const PreviewLinkForm = ({ FIELD_PATH, FIELD_VALUE, FIELD_LABEL }) => {
  // const [CURRENT_ENVIRONMENT, set_current_environment] = useState(DEVELOPMENT);

  return (
    <form className="container__form" onSubmit={handleSubmit}>
      {/* <div>
        <input
          type="radio"
          name="my-input"
          id={DEVELOPMENT}
          checked={CURRENT_ENVIRONMENT === DEVELOPMENT}
          onChange={handleChange}
        />
        <label htmlFor={DEVELOPMENT}>Development</label>
      </div>
      <div>
        <input
          type="radio"
          name="my-input"
          id={STAGING}
          checked={CURRENT_ENVIRONMENT === STAGING}
          onChange={handleChange}
        />
        <label htmlFor={STAGING}>Staging</label>
      </div> */}
      <button className="container__form__button">Preview {FIELD_LABEL} </button>
    </form>
  );

  // function handleChange(e) {
  //   const { id: CURRENT_ENVIRONMENT } = e.target;
  //   set_current_environment(CURRENT_ENVIRONMENT);
  // }

  function handleSubmit(e) {
    e.preventDefault();
    const CURRENT_ENVIRONMENT = 'DEPLOY';
    const PREVIEW_URL = get_preview_url(
      FIELD_VALUE,
      CURRENT_ENVIRONMENT,
      FIELD_PATH
    );
    window.open(PREVIEW_URL, "_blank");
  }
};

export default PreviewLinkForm;
